export default "__VITE_ASSET__k1tea7DW__"